import './App.css'
import styled, { StyleSheetManager } from 'styled-components'
import useScreenSize from './hooks/useScreenSize'
import Hero from './components/organisms/Hero'
import WhatWeDo from './components/organisms/WhatWeDo'
import * as Animation from './functionality/Animation'
import { useState, useCallback, useEffect } from 'react'
import CTA from './components/organisms/CTA'
import Footer from './components/molecules/Footer'

const unforwardedProps = [
    "textAlign",
    "flexDirection",
    "lineHeight",
]

const heroSectionHeightRatio: Animation.VariableValue = {
    end: 0.52,
    start: 1.6,
    endControl: 800,    // Width in px
    startControl: 400,  // Width in px
}

const ctaSectionHeight: Animation.VariableValue = {
    end: 700,
    start: 400,
    endControl: 1700,    // Width in px
    startControl: 400,  // Width in px
}

const App = () => {
    
    const screenSize = useScreenSize()
    const [ , setScrollPosition ] = useState(0)

    // Respond to scroll events
    const updateScrollPosition = useCallback(() => { console.log(window.scrollY); setScrollPosition(window.scrollY)}, [])

    useEffect(() => {
        window.addEventListener("scroll", updateScrollPosition)
        return () => {
            window.removeEventListener("scroll", updateScrollPosition)
        }
    }, [ updateScrollPosition ])

    // const onScroll = useCallback((e: UIEvent<HTMLDivElement>) => setScrollPosition(e.currentTarget.scrollTop), [ setScrollPosition ])

    // Get the height of the top and bottom sections
    const heroHeightRatioForThisWidth = Animation.calculateValue(heroSectionHeightRatio, screenSize.width)
    const heroSectionHeightInPx = (heroHeightRatioForThisWidth * screenSize.width)

    const ctaSectionHeightInPx = Animation.calculateValue(ctaSectionHeight, screenSize.width)

    // const time = new Date()
    // console.log(scrollPosition + "," + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds() + "." + time.getMilliseconds())

    return <Page>
        <StyleSheetManager shouldForwardProp={p => !p.includes("InPx") && !unforwardedProps.includes(p)}>
            <Hero widthInPx={screenSize.width} heightInPx={heroSectionHeightInPx}/>
            <WhatWeDo widthInPx={screenSize.width} screenHeightInPx={screenSize.height} startYInPx={heroSectionHeightInPx}/>
            <CTA widthInPx={screenSize.width} heightInPx={ctaSectionHeightInPx} screenHeightInPx={screenSize.height}/>
            <Footer widthInPx={screenSize.width}/>
        </StyleSheetManager>
    </Page>
}

export default App

const Page = styled.div`
    width: 100vw;
    /* height: 100vh; */
    overflow-x: hidden;
    /* overflow-y: auto; */
`